// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu')
	const menuOpenTarget = document.querySelector('body')
	//const dropDownMenu   = document.getElementById('js-site-menu')

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function() {
			dropDownButton.classList.toggle('is-close')
			menuOpenTarget.classList.toggle('is-menu-open')
			//dropDownMenu.classList.toggle('is-active')
		} )
	}



	// Site Navigation
	// --------------------------------------------------------------- //

	const header = document.getElementById('js-header');
	const observer = new window.IntersectionObserver( (entry) => {
		if (!entry[0].isIntersecting) {
			document.getElementById('js-site-nav').classList.add('is-sticky');
		} else {
			document.getElementById('js-site-nav').classList.remove('is-sticky');
		}
	});
	observer.observe(header);



	// Header Seach
	// --------------------------------------------------------------- //

	const headerSearchButton = document.getElementById('js-header-search')
	const headerSearchElement = headerSearchButton.nextElementSibling;
	const headerSearcInput = headerSearchElement.querySelector('input[type="text"]')

	if ( headerSearchButton ) {
		headerSearchButton.addEventListener('click', function() {
			headerSearchButton.classList.toggle('is-close')
			headerSearchElement.classList.toggle('is-open')

			if ( headerSearchElement.classList.contains('is-open') ) {
				headerSearcInput.focus();
			}
		} )
	}



	// Front Page Swiper
	// --------------------------------------------------------------- //

	const swiperId = document.getElementById('front-main-swiper')

	if ( swiperId ) {
		const swiper = new Swiper(swiperId, {
			loop: true,
			effect: "fade", // フェード切り替え
			// 自動再生
			autoplay: {
				delay: 5000, // 4秒後に次のスライドへ
				disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
			},
			speed: 2000, // 2秒かけてフェード
		});
	}

} );

